export const FETCH_USERS = 'FETCH_USERS';
export const UPDATE_ACTIVE_SORT_FIELD_USERS = 'UPDATE_ACTIVE_SORT_FIELD_USERS';
export const UPDATE_SEARCH_USERS = 'UPDATE_SEARCH_USERS';
export const CLEAR_SEARCH_USERS = 'CLEAR_SEARCH_USERS';
export const CREATE_USER = 'CREATE_USER';
export const FETCH_ADMIN_USER = 'FETCH_ADMIN_USER';
export const FETCH_ADMIN_USERS = 'FETCH_ADMIN_USERS';
export const TOGGLE_NOT_CONFIRMED_FILTER = 'TOGGLE_NOT_CONFIRMED_FILTER';
